module.exports = __webpack_public_path__ + "img/hr_flow.9f25046d.jpg";